import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

class SubscriptionIcon extends React.Component {

    render() {
        return (
            <SvgIcon {...this.props}>
                <g id="Group_190" data-name="Group 190" transform="translate(-1275 -18)">
                    <path id="Union_2" data-name="Union 2" d="M2,20a2.006,2.006,0,0,1-2-2V10A2.006,2.006,0,0,1,2,8H18a2.006,2.006,0,0,1,2,2v8a2.006,2.006,0,0,1-2,2ZM2,6V4H18V6ZM4,2V0H16V2Z" transform="translate(1277 20)" fill="#fff" />
                    <path id="Path_1474" data-name="Path 1474" d="M0,0H24V24H0Z" transform="translate(1275 18)" fill="none" />
                </g>
            </SvgIcon>
        );
    }
}

export default SubscriptionIcon;